import React from 'react';

import AutopayIcon from '@material-ui/icons/AccountBalanceTwoTone';
import { ListItem } from 'material-ui/List';
import { getTranslatedString } from 'helpers/i18n';

import { AccentColor } from 'helpers/AccentColorHelper';

const AutopayTodo = ({ routeToAutopay }) => {
  return (
    <ListItem
      onClick={routeToAutopay}
      primaryText={
        <div>
          <span style={{ textOverflow: 'ellipsis' }}>
            {getTranslatedString('todo.autopaySignup')}
          </span>
        </div>
      }
      leftIcon={<AutopayIcon style={{ color: AccentColor() }} />}
      style={{ fontSize: '15px', color: '#3e3e3e' }}
      tabIndex="1"
    />
  );
};

export default AutopayTodo;
